import { HttpClient, HttpParams, HttpHeaders, HttpResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../environments/environment';

// Services
import { FilterService } from './baseListFilter.service'

// Interface
import { Invoice } from '../interfaces/invoice';
import { SharedDataService } from './shared-data.service';
import { Message } from 'app/interfaces/message';
@Injectable({
  providedIn: 'root'
})
export class InvoiceService extends FilterService {
  private errorMessage: Message;

  constructor(
    protected httpClient: HttpClient,
    protected sharedData: SharedDataService
  ) {
    super()
    this.errorMessage = {
        status: 500
      , error: {errorMessage: 'Não Foi Possível Comunicar Com o Servidor!' }
      , ok: false
    }
  }

  fetchInvoiceData(invoiceId: string, invoiceSerie: string): Observable<Invoice> {
    const url = `$companyId/invoice/${invoiceSerie}/${invoiceId}`;
    const invoiceData = new Subject<Invoice>();
    this.httpClient.get<Invoice>(url).subscribe(
      data => {
        invoiceData.next(data)
      }, error => {
        invoiceData.error(error.status === 0 ? this.errorMessage : error)
      }
    )
    return invoiceData.asObservable();
  }

  getDataFiltered(params: HttpParams): Observable<HttpResponse<Invoice[]>> {
    return this.httpClient.get<Invoice[]>(`$companyId/invoice`, {observe: 'response', params})
  }

  getDanfeXml(documentId: string, serieId: string): Observable<any> {
    const params = new HttpParams()
      .set('documentId', documentId)
      .set('serieId', serieId);
  
    return this.httpClient.get<any>(`$companyId/getDanfe`, { params });
  }

}
